import IBankAccount from "@/module/main/dto/customer/IBankAccount";
import BankAccountType from "@/module/main/dto/customer/BankAccountTypeEnum";
import INational from "@/module/main/dto/customer/INational";
import IIban from "@/module/main/dto/customer/IIban";

export default class BankAccount implements IBankAccount {
    constructor(public type?: BankAccountType, public national?: INational, public iban?: IIban) {}
}
